// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yJHd","textarea":"styles_textarea__1Ra52"};